import { z } from 'zod';

import { Role } from '@optical/rbac';

import { isoDatetimeToDate } from '../codecs';

export type UserId = User['id'];

export type User = z.output<typeof userSchema>;
export type UserDTO = z.input<typeof userSchema>;

export const userSchema = z.object({
  /** ID of the user (sub) */
  id: z.string(),
  /** Date at which the user was created. */
  createdAt: isoDatetimeToDate,
  /** Email address of the user. */
  email: z.string(),
  /** Whether the user account is enabled or disabled. */
  enabled: z.boolean(),
  /** The user's first name. */
  firstName: z.string().optional(),
  /** The user's last name. */
  lastName: z.string().optional(),
  /** The user's phone number. */
  phone: z.string().optional(),
  /** List of roles the user has. */
  roles: z.array(z.enum(Role)),
  /**
   * Cognito account status. One of:
   * - ARCHIVED
   * - COMPROMISED
   * - CONFIRMED
   * - FORCE_CHANGE_PASSWORD
   * - RESET_REQUIRED
   * - UNCONFIRMED
   * - UNKNOWN
   */
  status: z.string(),
  /**
   * Tenant the user belongs to. Tolerant on decode because the upstream user service does not
   * return this field; it is filled in by the tenant service layer.
   */
  tenantId: z.string().nullable().catch(null),
  /** Date at which the user was last modified. */
  updatedAt: isoDatetimeToDate,
});

export const UserUtils = {
  getUsername(user: User): string {
    return user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email;
  },
};
